import { Deck } from "@/lib/classes/deck";
import type { DeckStringOptions } from "@/lib/classes/deck";

/**
 * Export deck to deck code string and copy to clipboard
 */
export async function exportDeckToCode(deck?: Deck): Promise<void> {
  try {
    if (deck) {
      const deckCode = deck.toDeckCode();
      await navigator.clipboard.writeText(deckCode);
      return;
    } else {
      throw new Error("No deck to export");
    }
  } catch (err) {
    console.error("Failed to generate deck code:", err);
    throw err;
  }
}

/**
 * Import deck from deck code string
 */
export function importDeckFromCode(deckCode: string, options: DeckStringOptions): Deck {
  return Deck.fromDeckCode(deckCode, options);
}

/**
 * Validate deck code format
 */
export function isValidDeckCode(code: string): boolean {
  // Basic validation - deck codes are typically base64-like strings
  return code.length > 0 && /^[A-Za-z0-9+/=_-]+$/.test(code);
}

